var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 9,
    fill: "none",
    viewBox: "0 0 13 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.167 3.6 13 .944v7.312L10.167 5.6v2.344a.578.578 0 0 1-.233.469.703.703 0 0 1-.5.187H.9a.703.703 0 0 1-.5-.187.616.616 0 0 1-.2-.47V1.257C.2 1.07.267.913.4.788A.703.703 0 0 1 .9.6h8.534c.2 0 .366.063.5.188a.578.578 0 0 1 .233.468V3.6Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgVideo);
export default Memo;